import React, { useContext } from 'react';

import { CustomsContext } from '../../context/context';
import type { CustomsContextValue } from '../../types';
import { CustomsCurrencyInput } from '../customs-currency-input';
import messages from '../messages';
import { Unknown } from '../../../../constants/currency-codes';

export const CustomsDutiesPaid = () => {
  const { defaultCurrencyCode, dutiesPaid, updateDutiesPaid }: CustomsContextValue = useContext(CustomsContext);

  const verifiedDutiesPaidValue = dutiesPaid?.value || 0;
  const verifiedDutiesPaidCode = dutiesPaid?.code && dutiesPaid?.code !== Unknown ? dutiesPaid.code : defaultCurrencyCode;

  return (
    <CustomsCurrencyInput
      currencyInputCode={verifiedDutiesPaidCode}
      currencyInputLabel={messages.dutiesPaidLabel}
      initialCurrencyInputValue={verifiedDutiesPaidValue}
      updateCurrencyValue={updateDutiesPaid}
    />
  );
};
